export const getRegionPricingVariationsMap = (globalPricingId: string) => {
  if (!globalPricingId) {
    return {};
  }

  return {
    variationsMap: {
      group_by: [
        {
          name: 'product_condition',
          field: 'data.product_condition',
        },
        {
          name: 'box_condition',
          field: 'data.box_condition',
        },
      ],
      values: {
        min_regional_price: {
          aggregation: 'min',
          field: `data.gp_lowest_price_cents_${globalPricingId}`,
        },
        min_regional_instant_ship_price: {
          aggregation: 'min',
          field: `data.gp_instant_ship_lowest_price_cents_${globalPricingId}`,
        },
      },
      dtype: 'object',
    },
    qsParam: {
      features: {
        display_variations: true,
      },
      feature_variants: {
        display_variations: 'matched',
      },
    },
  };
};
